import React from 'react'

import Icon from './Icon'
import type { IconProps } from './Icon'
import { ReactComponent as PlusCircle } from 'assets/svg/icon-plus-circle.svg'

function IconPlusCircle(props: IconProps): JSX.Element {
  const title = 'icon-plus-circle'
  const {
    className,
    id = title,
    name = title,
    variants = 'md',
    ...others
  } = props

  const svgProps = { id, name }

  return (
    <Icon className={className} variants={variants} {...others}>
      <PlusCircle {...svgProps} data-testid={title} />
    </Icon>
  )
}

export default IconPlusCircle
